import React, { useState } from "react";
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';


// Main App component with greeting and contact form
function App() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [sending, setSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setStatusMessage('');

    emailjs.send(
      'service_f2mdfok',
      'template_ikowrvb',
      {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message
      },
      'vzF6RndI3_Xtc5w5T'
    )
    .then(() => {
      setStatusMessage('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
      setSending(false);
    })
    .catch(() => {
      setStatusMessage('Failed to send message. Please try again.');
      setSending(false);
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (

    <div
      style={{
        minHeight: "100vh",
        textAlign: "center",
        marginTop: 0,
        background: "linear-gradient(135deg, #040214 0%, #08102f 100%)", // black-navy gradient
        color: "#fff",
        position: "relative"
      }}
    >
      <div style={{ width: "100%", background: "#fff", padding: "0px 0 0px 0", textAlign: "center" }}>
        <Link 
          to="/dotacja"
          style={{ cursor: "pointer", textDecoration: "none" }}
        >
          <img
            src="/images/unia_logo.png"
            alt="Logo"
            style={{
              width: "30%",
              maxWidth: "600px",
              height: "auto",
            }}
          />
        </Link>
      </div>
      <div>
        <img
          src="/images/logo_transparent4.png"
          alt="EMBERTRON Logo"
          style={{
            width: "500px",
            height: "auto",
            display: "block",
            margin: "80px auto 80px auto"
          }}
        />
      </div>
      <div>
        <div style={{
          maxWidth: "600px",
          margin: "0 auto 80px auto",
          color: "#ccc",
          fontSize: "1.1rem",
          lineHeight: 1.5
        }}>
          We develop software for embedded systems. We specialize in creating application software for i.MX6, i.MX8, Rockchip processors, as well as for low energy processors such as STM32 and STM8.
        </div>
      </div>
      
      {/* Line above Application Processors - Full Width */}
      <div style={{ width: "100%", height: "1px", background: "#0b3038", marginTop: "0px" }}></div>
      
      <div style={{
        maxWidth: "800px",
        margin: "10px auto 0 auto",
        padding: "0 20px",
        textAlign: "left"
      }}>

        {/* Header 1 - Application Processors */}
        <div id="app-processors" style={{ marginBottom: "40px", paddingBottom: "20px" }}>
          <h2 style={{ color: "#00a8cc", marginTop: 0, marginBottom: "10px" }}>Application Processors</h2>
          <p style={{ color: "#ccc", lineHeight: 1.6 }}>
            We develop comprehensive software solutions for Linux-based application processors, including NXP i.MX series, Digi ConnectCore, and Rockchip processors. 
            Our expertise covers the full spectrum of embedded Linux development, from kernel optimization 
            to user-space applications. We deliver high-performance, reliable software tailored to your specific needs.
          </p>
        </div>
      </div>

      <div style={{
        maxWidth: "800px",
        margin: "10px auto 0 auto",
        padding: "0 20px",
        textAlign: "left"
      }}>
        <div id="low-energy" style={{ marginBottom: "40px", paddingBottom: "20px" }}>
          <h2 style={{ color: "#00a8cc", marginTop: 0, marginBottom: "10px" }}>Low Energy Processors</h2>
          <p style={{ color: "#ccc", lineHeight: 1.6 }}>
            We specialize in firmware development for low-power microcontrollers from leading manufacturers 
            including ST Microelectronics, Nordic Semiconductor, and others. Our solutions optimize power consumption 
            while maintaining peak performance for IoT and battery-powered applications.
          </p>
        </div>
      </div>

      <div style={{
        maxWidth: "800px",
        margin: "10px auto 0 auto",
        padding: "0 20px",
        textAlign: "left"
      }}>
        {/* Header 3 - IoT Projects */}
        <div id="iot-projects" style={{ marginBottom: "40px", paddingBottom: "20px" }}>
          <h2 style={{ color: "#00a8cc", marginTop: 0, marginBottom: "10px" }}>IoT Projects</h2>
          <p style={{ color: "#ccc", lineHeight: 1.6 }}>
            We create end-to-end IoT solutions that combine embedded systems with web and mobile applications. 
            Our integrated approach ensures seamless connectivity, real-time data processing, and intuitive user interfaces 
            across all platforms.
          </p>
      </div>
      </div>

      <div style={{
        maxWidth: "800px",
        margin: "10px auto 0 auto",
        padding: "0 20px",
        textAlign: "left"
      }}>
        {/* Header 4 - Display Projects */}
        <div id="display-projects" style={{ marginBottom: "40px" }}>
          <h2 style={{ color: "#00a8cc", marginTop: 0, marginBottom: "10px" }}>Display Projects</h2>
          <p style={{ color: "#ccc", lineHeight: 1.6 }}>
            We develop sophisticated software for display-driven embedded systems. From graphical interfaces 
            to touch-screen interactions, we create responsive and visually stunning user experiences on 
            embedded hardware platforms.
          </p>
        </div>
      </div>

      {/* Line above Contact */}
      <div style={{ width: "100%", height: "1px", background: "#0b3038", marginTop: "10px" }}></div>
      
      <p style={{ textAlign: "center", marginTop: "50px", marginBottom: "50px", fontSize: "1.5rem" }}>
        If you want to contact us, please fill in the form below or <a href="mailto:contact@embertron.com" style={{ color: "#00a8cc", textDecoration: "underline", cursor: "pointer" }}>click here to send email</a>
      </p>

      {/* Contact form */}
      <form onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "0 auto 40px auto", display: "flex", flexDirection: "column", gap: "10px" }}>
        <input 
          type="text" 
          name="name" 
          value={formData.name}
          onChange={handleChange}
          placeholder="Full name" 
          required 
          style={{ padding: "10px", fontSize: "16px" }} 
        />
        <input 
          type="email" 
          name="email" 
          value={formData.email}
          onChange={handleChange}
          placeholder="Email" 
          required 
          style={{ padding: "10px", fontSize: "16px" }} 
        />
        <textarea 
          name="message" 
          value={formData.message}
          onChange={handleChange}
          placeholder="Message" 
          required 
          rows={4} 
          style={{ padding: "10px", fontSize: "16px" }} 
        />
        <button 
          type="submit" 
          disabled={sending}
          style={{ 
            padding: "10px", 
            fontSize: "16px", 
            background: sending ? "#666" : "#1976d2", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            cursor: sending ? "not-allowed" : "pointer" 
          }}
        >
          {sending ? 'Sending...' : 'Send'}
        </button>
        {statusMessage && (
          <p style={{ 
            textAlign: "center", 
            color: statusMessage.includes('success') ? "#4caf50" : "#f44336",
            margin: "10px 0 0 0"
          }}>
            {statusMessage}
          </p>
        )}
      </form>

      {/* Contact info at the bottom */}
      <div
        id="footer"
        style={{
          width: "100%",
          background: "#111",
          color: "#fff",
          padding: "20px 0 20px 0",
          fontSize: "1rem",
          letterSpacing: "1px",
          borderTop: "1px solid #333",
          marginTop: "60px"
        }}
      >
        <div style={{ marginBottom: "8px" }}>
          <strong>Embertron</strong>
        </div>
        <div style={{ marginBottom: "8px" }}>
          <strong>Contact: </strong><a href="mailto:contact@embertron.com" style={{ color: "#00a8cc", textDecoration: "none" }}>contact@embertron.com</a>
        </div>
        <div style={{ fontSize: "0.95rem", color: "#ccc", marginBottom: "0px" }}>
          ul. Dębowa 14a<br />
          43-365 Wilkowice<br />
          <div style={{ marginTop: "5px", paddingTop: "5px" }}>
            © 2026 EMBERTRON. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;